import { Autocomplete, Chip, TextField } from '@mui/material';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const InventoryBarcodes = ({
  name,
  label,
  control,
  readOnly = false,
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState('');

  const handleAddItem = (event, field) => {
    if (readOnly) return;

    const newValue = event.target.value;
    if (
      (event.key === ',' || event.key === 'Enter') &&
      newValue.trim() !== ''
    ) {
      const currentBarcodes = field.value || [];
      field.onChange([newValue.trim(), ...currentBarcodes]);
      setInputValue('');
      event.preventDefault();
    }
  };

  const handleBlur = (field) => {
    if (readOnly) return;

    // If there's text in the input when blur happens, add it to barcodes
    if (inputValue.trim() !== '') {
      const currentBarcodes = field.value || [];
      const trimmedValue = inputValue.trim();

      // Only add if it's not already in the list
      if (!currentBarcodes.includes(trimmedValue)) {
        field.onChange([trimmedValue, ...currentBarcodes]);
      }
      setInputValue('');
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        if (!Array.isArray(field.value)) {
          field.value = field.value ? [field.value] : [];
        }

        return (
          <Autocomplete
            {...field}
            multiple
            size="small"
            id="multiple-limit-barcodes"
            options={[]}
            freeSolo
            disableClearable={readOnly}
            onChange={(event, newValue) => {
              if (!readOnly) field.onChange(newValue);
            }}
            disabled={isDisabled}
            onKeyDown={(event) => handleAddItem(event, field)}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              if (!readOnly) setInputValue(newInputValue);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={index}
                  variant="outlined"
                  sx={{
                    background: '#ebebeb',
                    border: 'none',
                  }}
                  label={option}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label={label || t('Barcodes')}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    ...params.inputProps,
                    readOnly: readOnly,
                  }}
                  disabled={isDisabled}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message || ''}
                  onBlur={() => handleBlur(field)}
                  onChange={(event) => {
                    if (readOnly) return;

                    const valueWithComma = event.target.value.split(',');
                    if (
                      valueWithComma.length > 1 &&
                      event.target.value !== ','
                    ) {
                      const currentBarcodes = field.value || [];
                      const trimmedValues = valueWithComma
                        .map((v) => v.trim())
                        .filter((v) => v !== '');
                      field.onChange([...trimmedValues, ...currentBarcodes]);
                      setInputValue('');
                    } else {
                      setInputValue(event.target.value);
                    }
                  }}
                />
              );
            }}
            sx={{
              width: '100%',
              mr: 2,
            }}
          />
        );
      }}
    />
  );
};

export default InventoryBarcodes;
